



















import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtSku from "@/components/pages/ProductCreate/sku.vue";
@Component({ components: { gtSku } })
export default class skuTab extends Vue {
  @Prop({ default: false }) isEdit;
  @Prop({ default: false }) saveSkuSuccess: boolean;
  @Prop({ default: false }) readonly;
  private vaildates = [];
  isChangeSku = false;
  vaildateRegister(fn) {
    this.vaildates.push(fn);
  }
  vaildateRemove(fn) {
    let index = this.vaildates.findIndex(item => item === fn);

    if (index > -1) {
      this.vaildates.splice(index, 1);
    }
  }
  submit() {
    return Promise.all(this.vaildates.map(vaildate => vaildate()));
  }
  skuChangeProductStatus() {
    this.$emit("skuChangeProductStatus");
  }
  isChangeSkuFn(data) {
    this.isChangeSku = data;
    this.$emit("isChangeSku", data);
  }
}
